import { render, staticRenderFns } from "./Cinema-detail.vue?vue&type=template&id=40433315&scoped=true&"
import script from "./Cinema-detail.vue?vue&type=script&lang=js&"
export * from "./Cinema-detail.vue?vue&type=script&lang=js&"
import style0 from "./Cinema-detail.vue?vue&type=style&index=0&id=40433315&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40433315",
  null
  
)

export default component.exports